module.exports = __webpack_public_path__ + "img/DW_jszc.8a3508de.jpg";